import { useAppDispatch, useAppSelector } from '@core/hooks/redux-hooks';
import { EmptyValues } from '@app/shared/constants/empty-values';
import { NavigationItem } from '@app/shared/components/secondary-navigation/secondary-navigation-types';
import { SecondaryNavigation } from '@app/shared/components/secondary-navigation/SecondaryNavigation';
import { useParams } from 'react-router-dom';
import { useEffect, useMemo, useRef } from 'react';
import { SecondaryNavigationVariation } from '@app/shared/components/secondary-navigation/secondary-navigation-enums';
import { setCapitalStructureBuildStructureSelectedCase } from '@app/core/store/ui-values-slice';

interface EventSetNavigationControlsProps {
  resetFunction?: (() => void) | null;
}

export const EventSetNavigationControls = ({
  resetFunction,
}: EventSetNavigationControlsProps = {}) => {
  const dispatch = useAppDispatch();
  const { caseId } = useParams();
  const project = useAppSelector((state) => state.project.projectDraft);

  const prevCaseIdRef = useRef<string | undefined>(undefined);

  useEffect(() => {
    if (caseId) {
      dispatch(setCapitalStructureBuildStructureSelectedCase(caseId));
    }
    if (prevCaseIdRef.current !== undefined && prevCaseIdRef.current !== caseId && resetFunction) {
      resetFunction();
    }
    prevCaseIdRef.current = caseId;
  }, [caseId, dispatch, resetFunction]);

  const selectedCase = project.pwermInput.cases.find((item) => item.caseId === caseId);
  const selectedEventSetId = selectedCase?.eventSetId;

  const navigationItems: NavigationItem[] = useMemo(
    () =>
      project.pwermInput.cases
        .map((item) => ({
          label: item.narrative || EmptyValues.EnDash,
          route: ':caseId',
          params: { caseId: item.caseId },
          order: item.caseOrder,
          isHighlighted:
            selectedEventSetId === null
              ? item.eventSetId === null
              : item.eventSetId === selectedEventSetId,
        }))
        .sort((a, b) => a.order! - b.order!) || [],
    [project.pwermInput.cases, selectedEventSetId]
  );

  return (
    <SecondaryNavigation
      navigationItems={navigationItems}
      variation={SecondaryNavigationVariation.Scrollable}
    />
  );
};
